import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import Seo from "../components/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Confirm() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading");
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    fired.current = true;
    if (!token) {
      setState("invalid");
      return;
    }
    fetch(`${API}/subscribe/confirm?token=${encodeURIComponent(token)}`)
      .then((r) => r.json())
      .then((d) => setState(d.ok ? "ok" : "invalid"))
      .catch(() => setState("invalid"));
  }, [token]);

  return (
    <>
      <Seo title="Confirm Subscription | Boston Iron Grit" description="Confirm your subscription to The Grit Report." path="/confirm" noindex />
      <section className="min-h-[70vh] bg-[#0A0A0B] flex items-center justify-center px-6">
        <div className="w-full max-w-md bg-[#121214] border border-white/10 p-9 text-left" data-testid="confirm-card">
          {state === "loading" && (
            <div className="flex items-center gap-3 text-neutral-400" data-testid="confirm-loading">
              <Loader2 size={20} className="animate-spin text-[#9D0423]" />
              <p className="text-sm">Confirming your subscription…</p>
            </div>
          )}
          {state === "ok" && (
            <div data-testid="confirm-success">
              <CheckCircle2 size={36} className="text-[#9D0423]" />
              <h1 className="mt-5 font-heading font-extrabold uppercase text-2xl text-white tracking-tight">
                You're on the list.
              </h1>
              <p className="mt-3 text-[14px] text-neutral-400 leading-relaxed">
                The Grit Report lands once a month — training tips, member stories and challenge dates from Boston Iron Grit. No spam, unsubscribe anytime.
              </p>
              <Link to="/" className="mt-7 inline-flex items-center justify-center bg-[#9D0423] hover:bg-[#7E031C] text-white font-mono font-semibold text-[12px] uppercase tracking-[0.14em] px-6 py-3.5 transition-colors" data-testid="confirm-home-link">
                Back to the Site
              </Link>
            </div>
          )}
          {state === "invalid" && (
            <div data-testid="confirm-invalid">
              <XCircle size={36} className="text-neutral-500" />
              <h1 className="mt-5 font-heading font-extrabold uppercase text-2xl text-white tracking-tight">Link not valid</h1>
              <p className="mt-3 text-[14px] text-neutral-400 leading-relaxed">
                This confirmation link is invalid or expired. Sign up again from the footer form and we'll send a fresh one.
              </p>
              <Link to="/" className="mt-7 inline-flex items-center justify-center border border-white/20 hover:border-white/60 text-white font-mono font-semibold text-[12px] uppercase tracking-[0.14em] px-6 py-3.5 transition-colors">
                Back to the Site
              </Link>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
